module.exports = __webpack_public_path__ + "static/media/logout.8c407ea6.svg";